export default {
  setNotifications(state, data) {
    state.notifications = data.notif;
    state.notificationsCount = data.count;
  },
};
